import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'

import type {GiftReducers, MakeCreateSliceOptions} from './interfaces'
import type {GiftState} from '@web/slices/gift/slice'

const initialState: GiftState = {
    receivers: [],
    sessionKey: '',
    availableCount: 0,
    existsECouponCategoryProduct: false,
}

export default (options?: MakeCreateSliceOptions) =>
    createSlice<GiftState, GiftReducers, 'gift', SliceSelectors<GiftState>>({
        name: 'gift',
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.gift ?? state
            })
        },
    })
